module.exports = __webpack_public_path__ + "static/media/alejandra.3998538d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-us/alejandra.png
// module id = 1166
// module chunks = 0